export const VOLUME = 'VOLUME';
export const KNOB_1 = 'KNOB_1';
export const KNOB_2 = 'KNOB_2';
export const KNOB_3 = 'KNOB_3';
export const FILTER = 'FILTER';
export const DELAY = 'DELAY';
export const SEND_A = 'SEND_A';
export const PLAY = 'PLAY';
export const RECORD = 'RECORD';
export const CLEAR = 'CLEAR';

export const BROWSE_SOUNDS = 'BROWSE_SOUNDS';
export const CHANGE_START_SLICE = 'CHANGE_START_SLICE';
export const CHANGE_END_SLICE = 'CHANGE_END_SLICE';
export const CHANGE_SELECTED_TRACK = 'CHANGE_SELECTED_TRACK';
export const CHANGE_TRANSPOSE = 'CHANGE_TRANSPOSE';
export const CHANGE_VOLUME= 'CHANGE_VOLUME';

